export default __webpack_public_path__ + "static/media/user-white.f953f294.svg";